
import { locale } from "svelte-i18n";
import { push } from 'svelte-spa-router';
import { get } from "svelte/store";
import {info_client, access_token, client} from "../src/components/stores";
import {api} from "./helpers";
import { getBaseApiUrl } from '../src/api/base';

const debug = DEBUG;

export async function accessTokenRefresh(){
  const name_url = getBaseApiUrl();

  let response = await fetch(
    `${name_url}jwt-auth/api/content/token/refresh/`,
    {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({"refresh": localStorage.refresh_token}) // body data type must match "Content-Type" header
    }
  )

  if (response.ok){
    let data = await response.json()
    
    let accessToken = data.access

    // Обновляем access token в сторе
    access_token.update(() => accessToken);
  } else {
    push(`/token_error/`);
  }

  response = await fetch(
    `/api/v1/get-user-info/`, {
      headers: { 
        'Content-Type': "application/json", 
        'Authorization': `Secret ${get(access_token)}`,
      }
    }
  );

  if (response.ok){
    const data = await response.json();
    
    info_client.set(data);
    locale.set(data.language);

    if (data.flow.shop_icon_status !== 'available') {
      const clientResponse = await api(`${name_url}api/mobile/client/get_client_info/`)

      if (clientResponse.ok) {
        const clientData = await clientResponse.json();

        client.set(clientData)
      }
    }
    
    if (!data.active_content){
      push(`/access_error/`);
    }
  }
}
export async function CheckLocalStorage(){
  const name_url = getBaseApiUrl();

  if(!localStorage.refresh_token){
    const redirect_url = document.location.origin + '/';
    let redirect_query = `&redirect=${redirect_url}`
    window.location.replace(`${name_url}jwt-auth/redirect-refresh-token/to-content/?`+redirect_query)
  }
}